<template>
    <div class="footer">
        <router-link to="/impressum"></router-link>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        props: {
        },
        data: function () {
            return {};
        },
        computed: {
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
